import { Heading, TextBlock } from '@ui'

const component = (
    <>
        <div className="mb-5 m:mb-12 m:-mx-6 m:py-6 m:px-6 m:bg-sand-light">
            <Heading
                text="вскоре"
                className="m:hidden"
                size="s"
                component="h1"
            />
        </div>
    </>
)

export default component
